import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { Form, Field } from 'react-final-form';
import { css } from 'styled-components';
import NProgress from 'nprogress';

import Alert from '../../../common/components/basic/Alert';
import TextInput from '../../../common/components/form/TextInput';
import Link from '../../../common/components/basic/Link';
import Button from '../../../common/components/basic/Button';
import required from '../../../common/utils/validators/required';
import firebase from '../../../common/firebase';
import styles from '../../../common/utils/styles/css/styles';
import GmailLoginButton from './GmailLoginButton';
import TouchableItem from '../../../common/components/basic/TouchableItem';
import { Router } from '../../../common/libs/i18n';

export default function SigninForm() {
  const [error, setError] = useState();
  const { t } = useTranslation();
  const { query } = useRouter();

  async function handleSignin({ email, password }) {
    NProgress.inc();
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(error => {
        if (
          error.code === 'auth/invalid-email' ||
          error.code === 'auth/user-not-found' ||
          error.code === 'wrong-password'
        ) {
          setError(
            t(
              'signin.error.invalid_email_or_password',
              'Invalid email/password combination. Please try again.'
            )
          );
        } else {
          setError(error.message);
        }
      })
      .finally(() => {
        NProgress.done();
      });
  }
  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      <div
        css={css`
          margin-bottom: 24px;
        `}
      >
        <h1>{t('signin.form.title', 'Login')}</h1>
        <p>{t('signin.form.subtitle', 'Welcome back to Rupiah Token')}</p>
      </div>
      {query.verified && (
        <Alert
          type="success"
          title={t('signin.alert.email_verified.title', 'Email verified!')}
          description={t('signin.alert.email_verified.subtitle', 'You can now log in.')}
        />
      )}
      {query.reset && (
        <Alert
          type="success"
          title={t('signin.alert.reset_pasword.title', 'Password has been reset!')}
          description={t('signin.alert.reset_pasword.subtitle', 'You can now log in.')}
        />
      )}
      {!!error && (
        <div css={styles.mvm}>
          <Alert type="danger" title="Error" description={error} />
        </div>
      )}
      <Form
        onSubmit={handleSignin}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              component={TextInput}
              name="email"
              type="email"
              label={t('signin.form.email.label', 'Email')}
              placeholder={t('signin.form.email.placeholder', 'Input your email')}
              required="required"
              validate={required}
              autoFocus
            />
            <Field
              component={TextInput}
              name="password"
              type="password"
              label={t('signin.form.password.label', 'Password')}
              placeholder={t('signin.form.password.placeholder', 'Input your password')}
              required="required"
              validate={required}
            />
            <div css={[styles.tar, styles.mvm]}>
              <Link href="/signin/reset">
                {t('signin.form.forgot_password.button', 'Forgot Password')}
              </Link>
            </div>
            <Button
              onClick={handleSubmit}
              buttonType="submit"
              text={t('signin.form.signin.button.default', 'Sign in')}
            />
          </form>
        )}
      />
      <div css={styles.mvl}>
        <div
          css={[
            styles.mvl,
            styles.tac,
            css`
              ::before {
                content: '';
                position: absolute;
                background: ${({ theme: { colors } }) => colors.dark.light};
                height: 1px;
                left: 0;
                right: 0;
                top: 50%;
              }
            `
          ]}
        >
          <span
            css={css`
              background: ${({ theme: { colors } }) => colors.light.primary};
              padding: 12px;
            `}
          >
            {t('signin.form.or_login_with', 'Or Login With')}
          </span>
        </div>
        <GmailLoginButton />
      </div>
      <p css={[styles.mtl, styles.tac]}>
        {t('signin.form.dont_have_an_account', 'Don’t have an account?')}
        &nbsp;
        <TouchableItem onClick={() => Router.push('/register')}>
          <b css={styles.fcp}>{t('signin.form.register_button', 'Register')}</b>
        </TouchableItem>
      </p>
    </div>
  );
}
